import React from 'react';
import Icon from '../../../components/AppIcon';

const MarketRiskVisualization = ({ customers }) => {
  const totalRevenue = customers?.reduce((sum, c) => sum + (c?.volume * 8500), 0);
  
  const concentrationData = customers?.map(c => ({
      name: c?.name,
      percentage: c?.dependencyPercentage,
      revenue: c?.volume * 8500
    }))?.sort((a, b) => b?.percentage - a?.percentage)?.slice(0, 5);

  const top3Concentration = concentrationData?.slice(0, 3)?.reduce((sum, c) => sum + c?.percentage, 0);

  const getRiskLevel = () => {
    if (top3Concentration >= 60) return { level: 'Kritis', color: 'text-error', bg: 'bg-error/10' };
    if (top3Concentration >= 40) return { level: 'Tinggi', color: 'text-warning', bg: 'bg-warning/10' };
    if (top3Concentration >= 25) return { level: 'Sedang', color: 'text-warning', bg: 'bg-warning/10' };
    return { level: 'Rendah', color: 'text-success', bg: 'bg-success/10' };
  };

  const risk = getRiskLevel();

  return (
    <div className="space-y-6">
      {/* Risk Summary Card */}
      <div className={`rounded-xl border-2 p-6 ${risk?.bg} border-current`}>
        <div className="flex items-start gap-4">
          <div className={`w-12 h-12 rounded-lg ${risk?.bg} flex items-center justify-center flex-shrink-0`}>
            <Icon name="AlertTriangle" size={24} className={risk?.color} />
          </div>
          <div className="flex-1">
            <h3 className="text-lg font-semibold text-foreground mb-2">
              Risiko Konsentrasi Pelanggan: {risk?.level}
            </h3>
            <p className="text-sm text-muted-foreground mb-3">
              3 pelanggan teratas menyumbang {top3Concentration?.toFixed(1)}% dari total pendapatan
            </p>
            <div className="flex items-center gap-2">
              <div className="flex-1 h-3 bg-background rounded-full overflow-hidden">
                <div 
                  className={`h-full ${risk?.color?.replace('text-', 'bg-')} transition-all duration-500`}
                  style={{ width: `${Math.min(top3Concentration, 100)}%` }}
                />
              </div>
              <span className={`text-sm font-semibold data-text ${risk?.color}`}>
                {top3Concentration?.toFixed(1)}%
              </span>
            </div>
          </div>
        </div>
      </div>
      {/* Top Customers Breakdown */}
      <div className="space-y-4">
        <h4 className="text-sm font-semibold text-foreground">Distribusi Pendapatan Top 5</h4>
        {concentrationData?.map((customer, index) => (
          <div key={index} className="space-y-2">
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-2">
                <span className="text-sm font-medium text-foreground">{customer?.name}</span>
                <span className={`text-xs px-2 py-0.5 rounded-full ${
                  customer?.percentage >= 30 ? 'bg-error/10 text-error' :
                  customer?.percentage >= 15 ? 'bg-warning/10 text-warning': 'bg-success/10 text-success'
                }`}>
                  #{index + 1}
                </span>
              </div>
              <div className="text-right">
                <p className="text-sm font-semibold text-foreground data-text">
                  {customer?.percentage?.toFixed(1)}%
                </p>
                <p className="text-xs text-muted-foreground">
                  Rp {(customer?.revenue / 1000000)?.toFixed(1)}jt
                </p>
              </div>
            </div>
            <div className="h-2 bg-muted rounded-full overflow-hidden">
              <div 
                className={`h-full transition-all duration-500 ${
                  customer?.percentage >= 30 ? 'bg-error' :
                  customer?.percentage >= 15 ? 'bg-warning': 'bg-success'
                }`}
                style={{ width: `${customer?.percentage}%` }}
              />
            </div>
          </div>
        ))}
      </div>
      {/* Diversification Metrics */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div className="bg-card rounded-lg border border-border p-4">
          <div className="flex items-center gap-3 mb-2">
            <Icon name="Users" size={20} color="var(--color-primary)" />
            <span className="text-sm text-muted-foreground">Total Pelanggan</span>
          </div>
          <p className="text-2xl font-bold text-foreground data-text">{customers?.length}</p>
        </div>
        <div className="bg-card rounded-lg border border-border p-4">
          <div className="flex items-center gap-3 mb-2">
            <Icon name="TrendingUp" size={20} color="var(--color-primary)" />
            <span className="text-sm text-muted-foreground">Pendapatan Bulanan</span>
          </div>
          <p className="text-2xl font-bold text-foreground data-text">
            Rp {(totalRevenue / 1000000)?.toFixed(1)}jt
          </p>
        </div>
      </div>
    </div>
  );
};

export default MarketRiskVisualization;